// import * as originPackageService from '../../../services/originPackage'

import * as companyBillService from "../../../services/companyBill";
import * as companyService from "../../../services/company";
import * as settings from "../../../services/settings";

import { ArrowLeftOutlined, DeleteOutlined, DownOutlined, EditOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import AuthGroup from "../../../../configs/authgroup";
import { usePermission, useUser } from "../../../hooks/usePermission";

import { CompanyBiller } from "../../../Components/exportBillers/exportPDF/companyBiller";
import { CompanyBillerInvoice } from "../../../Components/exportBillers/exportPDF/companyBillerInvoice";
import { Form } from "antd";
import { ModalDelete } from "../../../Components/model/modal/delete";
import dayjs from "dayjs";
import { formatNumber } from "../../../utils/number";
import permissions from "../../../../configs/permission";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { useReactToPrint } from "react-to-print";
import { useTranslation } from "react-i18next";

const initPage = { limit: 10, page: 1 };
// let promise
export const CompanyBillPage = () => {
  const { hasPermission, isSuperuser, hasGroup } = usePermission();
  const { accessToken } = useAccessToken();
  const hasFetchedRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation("companybill", "buttons", "common");
  const { t: tOps } = useTranslation("options", { keyPrefix: "Bill" });
  const [search, setSearch] = useState(initPage);
  const [customerBill, setCustomerBill] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { Title, Link } = Typography;
  const { Search } = Input;
  const [total, setTotal] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalInvoice, setIsOpenModalInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [isOpenButton, setIsOpenButton] = useState(true);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const location = useLocation();
  const [api, contextHolder] = notification.useNotification();
  const [from] = Form.useForm();
  const [dateRange, setDateRange] = useState([]);
  const [pageDP, setPageDP] = useState(1);
  const [searchData, setSearchData] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [selectCompanyList, setSelectCompanyList] = useState([]);
  const { RangePicker } = DatePicker;
  const [countSelect, setCountSelect] = useState(0);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const { companyId, saleId } = useUser();
  const [tempSearch, setTempSearch] = useState();

  const defaultUserData = {
    company_id: companyId,
    sale_id: saleId,
  };

  const EXPORT_ALL_MAX = 5000;
  const navigate = useNavigate();
  const openNotificationWithIcon = useCallback(
    (type, message, description) => {
      api[type]({ message, description });
    },
    [api]
  );

  //set localstorage language
  localStorage.setItem("lang", i18n.language);

  const onDeleteCompanyBill = async (data) => {
    let prepareDeleteOriginPackage = {
      id: data.id,
    };

    try {
      const response = await companyBillService.deleteCompanyBill(accessToken, prepareDeleteOriginPackage);

      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Delete_Success", { ns: "common" })
      );
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      setLoading(false);
      fetchCompanyBill({ ...search });
    } catch (err) {
      console.error("[CompanyBillPage] onDeleteCompanyBill: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      setLoading(false);
    }
  };

  const fetchCompanyBill = useCallback(
    async (param, searchTerm) => {
      try {
        setLoading(true);
        if (location.state != undefined && location.state.originTransportationId.length > 0) {
          const queryParamString = location.state.originTransportationId.join(",");
          param.origin_transportation_id = queryParamString;
        }

        // Send the query parameter
        if (searchTerm) {
          param.origin_transportation_id = searchTerm;
        }

        const data = await companyBillService.getCompanyBill(accessToken, param);
        if (data) {
          setTotal(data.totalCount);
          setCustomerBill(data.queryCompanyBill);
          setSearch({ ...param });
        }
      } catch (err) {
        console.error("[CompanyBillPage] fetchCompanyBill: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const onSearch = async (value) => {
    const { bill_status, company_id, search, search_date } = value;

    let start_date;
    let end_date;
    if (search_date) {
      start_date = dateRange[0] || undefined;
      end_date = dateRange[1] || undefined;
    }

    const values = {
      start_date: start_date,
      end_date: end_date,
      id: !isNaN(Number(search)) ? search : undefined,
      container: isNaN(Number(search)) ? search : undefined,
      bill_no: !isNaN(Number(search)) ? search : undefined,
      bill_status: normalizeSelection(bill_status),
      company_id: normalizeSelection(company_id),
    };

    setTempSearch(value);
    try {
      await fetchCompanyBill({ ...values, page: value.page ?? initPage.page, limit: value.limit ?? initPage.limit }); // Assume this function fetches the data
    } catch (err) {
      console.error("[CompanyBillPage] onSearch: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    }
  };

  const normalizeSelection = (values) => {
    const modify = values !== "all" ? values : undefined;
    return modify;
  };

  const getCompanyList = async () => {
    try {
      const response = await companyService.getCompanysList(accessToken);
      setCompanyList(response);
    } catch (err) {
      console.error("[CompanyBillPage] fetchCompanyList: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    }
  };

  const getCompanyById = useCallback(
    async (id) => {
      try {
        let companyList = [];
        setLoading(true);
        const data = await companyService.getCompanyById(accessToken, id);
        companyList.push(data);
        setCompanyList(companyList);
      } catch (err) {
        console.error("[CustomerPage] fetchCustomerCompany: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const mappingCompanyOption = async () => {
    if (isSuperuser || !defaultUserData?.company_id) {
      await getCompanyList();
    } else {
      await getCompanyById(defaultUserData?.company_id);
    }
  };
  const optionCompanySelection = (companies = []) => {
    const hasMultiple = companies.length > 1;

    return [
      ...(hasMultiple ? [{ label: "All Company", value: "all" }] : []),
      ...companies.map((item, index) => ({
        label: `${item.company_name} (${item.company_code})`,
        value: item.id,
        key: `company-${index}-${item.id}`,
      })),
    ];
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    if (!accessToken || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    const initLoad = async () => {
      setLoading(true);
      try {
        await Promise.all([fetchCompanyBill({ ...defaultUserData, ...search }), mappingCompanyOption()]);
      } finally {
        setLoading(false);
      }
    };

    initLoad();
  }, [accessToken, location.state]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, newSelectedRows) => {
      setIsSelectAll(false);
      setSelectedRows(newSelectedRows);
      setIsOpenButton(newSelectedRowKeys.length === 0);
      setSelectedRowKeys(newSelectedRowKeys);
      setCountSelect(newSelectedRowKeys?.length || 0);
    },
  };
  const handleItemClick = () => {
    setIsOpenModal(true);
    handlePrint();
  };

  const handleItemClickInvoice = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item."
      );
      return;
    }
    setLoading(true);
    try {
      const data = await companyBillService.getCompanyBillInvoice(accessToken, selectedRowKeys);
      setInvoiceData(data ?? []);
      setIsOpenModalInvoice(true);
    } catch (err) {
      console.error("[CompanyBillPage] handleItemClickInvoice: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
    } finally {
      setLoading(false);
    }
  };

  const exportInvoiceExcel = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item."
      );
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        // invoice export จำกัดที่ 10 bills ต่อครั้ง (โหลด image + render หนัก)
        const INVOICE_ALL_MAX = 10;
        const { page, limit, ...searchFilters } = search;
        const exportLimit = Math.min(selectedCount, INVOICE_ALL_MAX);
        if (selectedCount > INVOICE_ALL_MAX) {
          setCountSelect(INVOICE_ALL_MAX);
        }
        response = await companyBillService.exportCompanyBillInvoiceAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await companyBillService.exportCompanyBillInvoice(accessToken, selectedRowKeys);
      }

      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename = serverFilename || `invoice-export-${dayjs().format("YYYY-MM-DD-HHmm")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CompanyBillPage] exportInvoiceExcel: ", err);
    } finally {
      setLoading(false);
    }
  };

  const handleItemClickExport = () => {
    onExport();
  };

  const onExportReportSummary = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item to export."
      );
      return;
    }
    if (selectedCount > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: selectedCount.toLocaleString(),
        })
      );
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        const { page, limit, ...searchFilters } = search;
        const exportLimit = Math.max(1, Math.min(Number(total) || selectedCount, selectedCount, EXPORT_ALL_MAX));
        response = await companyBillService.exportReportSummaryCompanyBillAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await companyBillService.exportReportSummaryCompanyBill(accessToken, selectedRowKeys);
      }

      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename =
        serverFilename || `summary_company_bill_${dayjs().format("YYYY_MM_DD_HHmmss")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CompanyBillPage] onExportReportSummary: ", err);
    } finally {
      setLoading(false);
    }
  };

  const onExport = async () => {
    const selectedCount = countSelect || selectedRowKeys?.length || 0;
    if (!selectedCount) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Please_Select_At_Least_One_Item", { ns: "common" }) || "Please select at least one item to export."
      );
      return;
    }
    if (selectedCount > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: selectedCount.toLocaleString(),
        })
      );
      setCountSelect(EXPORT_ALL_MAX);
      if (!isSelectAll && selectedRowKeys.length > EXPORT_ALL_MAX) {
        setSelectedRowKeys(selectedRowKeys.slice(0, EXPORT_ALL_MAX));
        setSelectedRows(selectedRows.slice(0, EXPORT_ALL_MAX));
      }
      return;
    }
    setLoading(true);
    try {
      let response;
      if (isSelectAll) {
        const { page, limit, ...searchFilters } = search;
        const selectedCount = countSelect || selectedRowKeys?.length || 0;
        const exportLimit = Math.max(1, Math.min(Number(total) || selectedCount, selectedCount));
        response = await companyBillService.exportCompanyBillAll(accessToken, {
          ...searchFilters,
          page: 1,
          limit: exportLimit,
        });
      } else {
        response = await companyBillService.exportCompanyBill(accessToken, { ids: selectedRowKeys });
      }
      // ดึง filename และ content-type จาก response header เพื่อรองรับทั้ง .xlsx และ .zip
      const contentDisposition = response.headers["content-disposition"] || "";
      const serverFilename = contentDisposition.match(/filename=([^\s;]+)/)?.[1];
      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("application/zip");
      const fallbackExt = isZip ? ".zip" : ".xlsx";
      const downloadFilename =
        serverFilename || `company-bill-export-${dayjs().format("YYYY-MM-DD-HHmm")}${fallbackExt}`;

      const blob = new Blob([response.data], { type: contentType || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setIsSelectAll(false);
      setIsOpenButton(true);
      setCountSelect(0);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Export_Success", { ns: "common" }) || "Export completed successfully."
      );
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), `${message}`);
      console.error("[CompanyBillPage] onExport: ", err);
    } finally {
      setLoading(false);
    }
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const columns = [
    {
      title: t("Company_Bill_Table.Table_Bill_No"),
      dataIndex: "bill_no",
      render: (_, record) => {
        if (!hasPermission(permissions.CompanyBill.VIEW)) {
          return <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>{record.bill_no}</span>;
        }
        return (
          <RouterLink
            to={`/bill/companybill/create?id=${record.id}&mode=edit`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {record.bill_no}
          </RouterLink>
        );
      },
    },
    {
      title: t("Company_Bill_Table.Table_Bill_Status"),
      dataIndex: "bill_status",
      render: (_, record) => {
        const statusMap = {
          PAID: tOps("Bill_Status.Paid"),
          UNPAID: tOps("Bill_Status.UnPaid"),
        };

        return <>{statusMap[record?.bill_status] || "-"}</>;
      },
    },
    {
      title: t("Company_Bill_Table.Table_Origin_Transportation"),
      dataIndex: "container",
      render: (_, record) => {
        let containerName = record.app_origintransportation.container;
        // let id = record.app_origintransportation.id;
        return <p>{containerName}</p>;
      },
    },
    {
      title: t("Company_Bill_Table.Table_Company"),
      dataIndex: "company_name",
      render: (_, record) => {
        let id = record.app_company.id;
        let companyName = record.app_company.company_name;
        let companyCode = record.app_company.company_code;
        return (
          <p>
            {id} <span> </span>
            {companyName}({companyCode})
          </p>
        );
      },
    },
    {
      title: t("Company_Bill_Table.Table_Total_Volume"),
      dataIndex: "package_total_volume",
      render: (value) => formatNumber(value, 4, "round"),
    },
    {
      title: t("Company_Bill_Table.Table_Gross_Weight"),
      dataIndex: "package_total_weight",
      render: (value) => formatNumber(value, 4, "round"),
    },
    {
      title: t("Company_Bill_Table.Table_Total_Bill_Amount"),
      dataIndex: "package_total_bill_amount",
      render: (value) => formatNumber(value, 4, "round"),
    },
    {
      title: t("Create_At", { ns: "common" }),
      dataIndex: "created_at",
      render: (_, record) => {
        const created_at = record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD HH:mm:ss") : "-";
        return <p>{created_at}</p>;
      },
    },
    {
      title: t("Update_At", { ns: "common" }),
      dataIndex: "updated_at",
      render: (_, record) => {
        const updated_at = record.updated_at != null ? dayjs(record.updated_at).format("YYYY-MM-DD HH:mm:ss") : "-";
        return <p>{updated_at}</p>;
      },
    },
    {
      title: t("Edit", { ns: "common" }),
      dataIndex: "edit",
      render: (_, row) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CompanyBill.CHANGE)}
          onClick={(e) => {
            e.stopPropagation();
            navigate("/bill/companybill/create", {
              state: { type: "EDIT", data: row },
            });
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Delete", { ns: "common" }),
      dataIndex: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CompanyBill.DELETE)}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const handleDateChange = (dates, dateStrings) => {
    setDateRange(dateStrings);
  };

  const disableFutureDates = (current) => {
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const onFinish = async () => {
    const values = from.getFieldsValue();

    try {
      setLoading(true);
      setSearch({ ...values });
      await onSearch({ ...values, ...initPage });
    } finally {
      setLoading(false);
    }
  };

  const reset = async () => {
    from.resetFields();
    setDateRange([]);

    try {
      setLoading(true);
      setCountSelect(0);
      await fetchCompanyBill({ ...defaultUserData, ...initPage });
    } finally {
      setLoading(false);
    }
  };

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    {
      title: (
        <a href="/bill/companybill" style={{ fontWeight: 600, color: "black" }}>
          {t("Title_Company_Bill")}
        </a>
      ),
    },
  ];

  const selectStatusBill = [
    { value: "all", label: "All Status" },
    { value: "PAID", label: tOps("Bill_Status.Paid") },
    { value: "UNPAID", label: tOps("Bill_Status.UnPaid") },
  ];

  const onSelectAll = () => {
    if (total > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: total.toLocaleString(),
        })
      );
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setIsSelectAll(true);
      setCountSelect(EXPORT_ALL_MAX);
      setIsOpenButton(false);
      return;
    }
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setIsSelectAll(true);
    setCountSelect(total);
    setIsOpenButton(false);
  };

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        {isOpenModal && hasPermission(permissions.CompanyBill.EXPORT) ? (
          <CompanyBiller setIsOpenModal={setIsOpenModal} isOpenModal={isOpenModal} data={selectedRows} />
        ) : null}
        {isOpenModalInvoice && hasPermission(permissions.CompanyBill.PRINT_INVOICE) ? (
          <CompanyBillerInvoice
            setIsOpenModal={setIsOpenModalInvoice}
            isOpenModal={isOpenModalInvoice}
            data={invoiceData}
          />
        ) : null}

        <Row flex={1}>
          <Col span={24}>
            <Breadcrumb items={items}></Breadcrumb>
            <Row style={{ padding: "15px 0px" }}>
              <Col span={24}>
                <Title
                  level={4}
                  style={{
                    textWrap: "nowrap",
                    display: "flex",
                    gap: "7px",
                  }}
                >
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {t("Title_Company_Bill")}
                </Title>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Form Search */}
        <Row style={{ display: "flex", justifyContent: "left", overflowX: "auto" }}>
          <Col span={12}>
            <Form
              form={from}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              labelAlign="left"
              layout="horizontal"
              onFinish={onFinish}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  from.submit();
                }
              }}
              initialValues={{
                search: undefined, // Initial value for search
                bill_status: "all", // Initial value for package status
                company_id: defaultUserData?.company_id || "all", // Initial value for origin
              }}
            >
              <Row flex={1}>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item name="search_date" label={t("Create_At", { ns: "common" })}>
                    <RangePicker
                      allowEmpty
                      style={{ width: "100%", minWidth: 200 }}
                      onChange={handleDateChange}
                      disabledDate={disableFutureDates}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item name="search" label={t("Search", { ns: "common" })}>
                    <Input size="default" placeholder="Id / Bill No/ Origin Transportation" style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search.Bill_Status")} name="bill_status">
                    <Select
                      placeholder={t("Please_Select", { ns: "common" })}
                      options={selectStatusBill}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={t("Search.Company")} name="company_id" key="company_id">
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      showSearch
                      placeholder={t("Please_Select", { ns: "common" })}
                      allowClear
                      options={optionCompanySelection(companyList)}
                      filterOption={filterOption}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="end" align="middle">
                <Col span={24} style={{ textAlign: "end" }}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      {t("BTN_Search", { ns: "buttons" })}
                    </Button>
                    <Button type="default" onClick={() => reset()} style={{ marginLeft: "5px" }}>
                      {t("BTN_Reset", { ns: "buttons" })}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row align="middle" justify="end">
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "1rem",
            }}
          >
            <Space>
              {hasPermission(permissions.CompanyBill.PRINT_INVOICE) && (
                <Dropdown
                  disabled={isOpenButton}
                  menu={{
                    items: [
                      {
                        key: "pdf",
                        label: "PDF",
                        onClick: handleItemClickInvoice,
                      },
                      {
                        key: "excel",
                        label: "Excel",
                        onClick: exportInvoiceExcel,
                      },
                    ],
                  }}
                  placement="bottomLeft"
                >
                  <Button type="primary" disabled={isOpenButton}>
                    <Space>
                      {t("Button_Company_Bill.BTN_Print_Invoice")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              )}
              {hasPermission(permissions.CompanyBill.PRINT) && (
                <Button
                  disabled={isOpenButton}
                  type="primary"
                  onClick={() => {
                    handleItemClick();
                  }}
                >
                  {t("Button_Company_Bill.BTN_Print")}
                </Button>
              )}
              {hasPermission(permissions.CompanyBill.EXPORT) && (
                <Button
                  disabled={isOpenButton}
                  type="primary"
                  onClick={() => {
                    handleItemClickExport();
                  }}
                >
                  {t("Button_Company_Bill.BTN_Export")}
                </Button>
              )}
              {hasPermission(permissions.CompanyBill.EXPORT_REPORT_SUMMARY) &&
                (isSuperuser ||
                  hasGroup(AuthGroup.CompanyAccount1) ||
                  hasGroup(AuthGroup.PlatformAccount3) ||
                  hasGroup(AuthGroup.PlatformAccount2) ||
                  hasGroup(AuthGroup.PlatformAccount1)) && (
                  <Button disabled={isOpenButton} type="primary" onClick={onExportReportSummary}>
                    {t("Button_Company_Bill.BTN_Report_Summary_Company_Bill")}
                  </Button>
                )}
            </Space>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            {`${t("Select", { ns: "common" })}: ${countSelect} to ${total}`}&nbsp;
            <Link onClick={onSelectAll} target="_blank">
              {t("Select_All", { ns: "common" })}
            </Link>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Table
                loading={loading}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={customerBill}
                scroll={{ x: "max-content" }}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: search.limit,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  current: search.page,
                  pageSize: search.limit,
                  total: total,
                  onChange: async (page, limit) => {
                    onSearch({ ...tempSearch, page, limit });
                  },
                  showSizeChanger: true,
                }}
                style={{ cursor: "pointer" }}
              />
            </Card>
          </Col>
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCompanyBill(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
